import { context } from "../components/wr-context";
import request from "./request";
var logTransaction = function(transaction) {
    return request({
        url: "".concat(context.constants.host, "/beta/transactions/create"),
        method: "POST",
        body: '{"data": '.concat(JSON.stringify(transaction), "}")
    });
};
export var config = function() {};
export var generateTransaction = function(param) {
    var action = param.action, type = param.type, id = param.id, hname = param.hname, processTransaction = param.processTransaction;
    var geo = null;
    var wrsrc = null;
    var user = context.state.user;
    var actionType = type ? "".concat(type, " '").concat(hname, "'") : "";
    // let queue = []
    if (!context.constants.transactionsEnabled) {
        console.warn("Tried to Log Transaction without transactions being enabled");
        return;
    }
    // if (!geo) {
    //   queue.push({ action, type, id, hname })
    //   return
    // }
    var transaction = {
        parentType: "catalog",
        parentId: context.constants.client.catalogIds[0],
        requestData: {
            object: {
                type: type,
                id: id,
                name: hname || id,
                verb: action
            },
            partner: {},
            source: wrsrc || {},
            location: geo
        },
        companyId: context.constants.client.companyId,
        referer: window.location.href
    };
    if (user) {
        transaction.description = "User '".concat(user.email, "' ").concat(action, " ").concat(actionType);
        transaction.requestData.user = {
            id: user.id,
            email: user.email
        };
    } else {
        transaction.description = "A Guest ".concat(action, " ").concat(actionType);
    }
    context.utils.transactions.processTransaction(transaction);
    if (processTransaction) processTransaction(transaction);
    if (process.env.NODE_ENV === "production") {
        logTransaction(transaction);
    } else {
        console.log("logging", transaction);
    }
};
